import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import RolesListTopbar from "../../features/manageSubAdmin/rolesTopbar";
import RolesList from "../../features/manageSubAdmin/rolesList";
import { useEffect, useState } from "react";
import useAuth from "../../hooks/useAuth";
import { ROLES } from "../../utils/enums";
import useTranslation from "../../hooks/traslation";

const ManageSubadminRoles = () => {
  const navigate = useNavigate();
  const translation = useTranslation();
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const user = useAuth();

  useEffect(() => {
    if (user?.role === ROLES.SUB_ADMIN) {
      navigate("/permission-denied", { replace: true });
    }
  }, [user]);

  return (
    <MainContainer>
      <div className="main_title">
        <h1>{translation.main.mangeRoles}</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>
            {translation.dashboard.dashboard}
          </span>{" "}
          -{" "}
          <span onClick={() => navigate("/manage-subadmin")}>
            {translation.main.manageSubadmin}
          </span>{" "}
          - {translation.main.mangeRoles}
        </p>
      </div>

      <div className="cards">
        <RolesListTopbar setDebouncedSearchTerm={setDebouncedSearchTerm} />
        <RolesList debouncedSearchTerm={debouncedSearchTerm} />
      </div>
    </MainContainer>
  );
};

export default ManageSubadminRoles;
